import React from "react";
import CustomModalV1 from "components/custom-modal/CustomModalV1";
import Button from "components/button/Button";
import { CheckCircleIcon } from "images/image-component";
import "./success-modal.css";

interface Props {
  isOpen: boolean;
  message: string;
  handleClose: () => void;
}

function SuccessModal({ isOpen, message, handleClose }: Props) {
  return (
    <CustomModalV1 isOpen={isOpen} handleClose={handleClose}>
      <div className="v1-success-modal">

        <div className="v1-success-icon">
          <CheckCircleIcon />
        </div>

        <h3 className="v1-success-title">Success</h3>
        <p className="v1-success-msg">{message}</p>

        <div className="v1-success-actions">
          <Button variant="subtle" onClick={handleClose}>
            Close
          </Button>
        </div>

      </div>
    </CustomModalV1>
  );
}

export default SuccessModal;
